module.exports = __webpack_public_path__ + "img/unlock-multicolor-round-gif.8912b44a.gif";